import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/annual", label: "年度盘点" },
  { to: "/monthly", label: "月度总结" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

const topicLinks = ["文娱风云", "商业大瓜", "竞技名场面", "社会热点", "年度瓜王", "月度黑马"];

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-wifi-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-lg text-primary-600">吃瓜榜单</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-6">
              一站式回顾年度盘点与月度总结，从年度瓜王到月度黑马，帮你把错过的瓜都补上，吃瓜不断档。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["年度盘点", "月度总结", "瓜王", "热度"].map((t) => (
                <span
                  key={t}
                  className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-900">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-semibold text-foreground-900">热门栏目</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {topicLinks.map((t) => (
                <li key={t}>
                  <Link to="/annual" className="transition-colors hover:text-primary-600">
                    {t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 吃瓜榜单 · 专注把每一口瓜讲清楚，理性吃瓜，不断档。
          </p>
          <div className="flex items-center gap-4 text-sm">
            <a href="mailto:hello@chiguabangdan.example" className="flex items-center gap-1 hover:text-primary-600">
              <i className="ri-mail-line" aria-hidden="true"></i>
              <span className="whitespace-nowrap">hello@chiguabangdan.example</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}